import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';

import { font } from '@styles/fonts';

import Field from '@v2/elements/Fields';
import FieldsWrapper from '@v2/elements/FieldsWrapper';
import { webTimeCalculation } from '@services/webTimeCalculation';

import { InputsTypes } from '@v2/context/Times/page/interfaces';

export default ({ storage, manual, C, context, automatic, underlineText, loading }: InputsTypes) => {
  return (
    <View>
      <FieldsWrapper>
        <Field
          {...{
            name: storage.name,
            value: manual.value ? storage.value || '0:00:00' : automatic,
            setValue: storage.change,
            device: 'phone',
            borderBottom: true,
            variant: manual.value ? 'Edit' : 'Show',
            placeholder: i18n.t(loading ? 'Loading' : 'Set Manually'),
            type: 'Key-Value time 0:00:00',
            disabled: !manual.value,
          }}
        />
        <Field
          {...{
            name: 'Automatic',
            value: !manual.value,
            setValue: (newManualValue: boolean) => {
              // note: if switching from automatic to manual, set manual to automatic value
              if (newManualValue && !storage.value && automatic) {
                const automaticInSeconds = webTimeCalculation(automatic);
                storage.change(automaticInSeconds);
              }
              manual.change(newManualValue);
            },
            device: 'phone',
            type: 'Key-Switch - Phone',
            mainColor: C('System/Light/Teal'),
          }}
        />
      </FieldsWrapper>
      <View style={{ paddingHorizontal: scale(15), marginTop: scale(3) }}>
        <Text style={[font['Caption 1'], { color: C('Label/Light/Tertiary') }]}>{underlineText}</Text>
      </View>
    </View>
  );
};
